// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreatePeriodInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/create_period
 *
 * Validates input for creating a payroll period for a specific employee.
 */
import { registerContract } from './validate'

export interface Payroll_CreatePeriodInput {
franchise_id: number
user_id: string
start_date: string
end_date: string
}

registerContract('Payroll_CreatePeriodInput', {
  franchise_id: { type: 'number',  required: true },
  user_id:      { type: 'string',  required: true },
  start_date:   { type: 'string',  required: true },
  end_date:     { type: 'string',  required: true },
})
